
import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import Navbar from './components/Navbar';
import Header from './components/Header';

import React, {Fragment} from 'react';

import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import Aboutme from './components/Aboutme';
import Experience from './components/Experience';
import Contact from './components/ContactUs';
import Projects from './components/Projects';
import Wall from './components/WallOfFame';
import Accomplishments from './components/Accomplishments'


function App() {
  return (
    <Router>
    <Fragment>
    <Navbar></Navbar>
    <Route exact path="/" component = {Header} />
    <section >
        <switch>
       
            <Route exact path="/aboutme" component= { Aboutme }  />  
            <Route exact path="/experience" component= { Experience }  />  
            <Route exact path="/contact" component= { Contact }  />  
            <Route exact path="/projects" component= { Projects }  />  
            <Route exact path="/accomplishments" component= { Accomplishments }  /> 
            <Route exact path="/wall-of-fame" component= { Wall }  />   
             
          </switch>
    </section>
   </Fragment>
   </Router>
  );
}

export default App;
